// extracted by mini-css-extract-plugin
export default {"containerText":"Steps_containerText__SzUPk","containerPas":"Steps_containerPas__2Nv38"};